import { useSetAtom } from 'jotai'
import { useEffect } from 'react'
// ⚠️ import lazy agar tidak error saat router context tidak ada
import { useMatches } from 'react-router-dom'
import { currentModuleNameAtom } from '@/atoms'

export function ModuleNameSyncer() {
  const setCurrentModule = useSetAtom(currentModuleNameAtom)
  let matches: any[] = []

  try {
    matches = useMatches()
  } catch {
    setCurrentModule(null)
  }

  useEffect(() => {
    if (matches.length) {
      const active = matches.find(m => (m.handle as any)?.name)
      setCurrentModule((active?.handle as any)?.name ?? null)
      return
    }
  }, [matches, setCurrentModule])

  return null
}
